import { motion } from "framer-motion";

/**
 * AmbientMesh — soft aurora blobs that live behind the app content.
 * Fixed, non-interactive, subtle in light mode, deeper in dark mode.
 */
export function AmbientMesh() {
  return (
    <div
      aria-hidden="true"
      data-testid="ambient-mesh"
      className="pointer-events-none fixed inset-0 z-0 overflow-hidden"
    >
      <motion.div
        className="mesh-blob"
        style={{
          width: 640,
          height: 640,
          left: "-10%",
          top: "-15%",
          background:
            "radial-gradient(circle at center, hsl(var(--mesh-a)) 0%, transparent 65%)",
        }}
        animate={{ x: [0, 40, -20, 0], y: [0, 20, -10, 0] }}
        transition={{ duration: 22, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="mesh-blob"
        style={{
          width: 520,
          height: 520,
          right: "-8%",
          top: "20%",
          background:
            "radial-gradient(circle at center, hsl(var(--mesh-b)) 0%, transparent 65%)",
        }}
        animate={{ x: [0, -30, 20, 0], y: [0, 30, -20, 0] }}
        transition={{ duration: 28, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="mesh-blob"
        style={{
          width: 480,
          height: 480,
          left: "35%",
          bottom: "-15%",
          background:
            "radial-gradient(circle at center, hsl(var(--mesh-c)) 0%, transparent 65%)",
        }}
        animate={{ x: [0, 20, -30, 0], y: [0, -25, 15, 0] }}
        transition={{ duration: 30, repeat: Infinity, ease: "easeInOut" }}
      />
    </div>
  );
}
